<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [title]="'Recurring Task'"
      [class]="extraClass"
      [canGoBack]="true"
      [showLinkIcon]="true"
      [linkIcon]="'share'"
      (linkAction)="shareTask()"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (maintenance) {
        <tidy-row>
          <tidy-text
            [body]="isSavingChanges ? 'Saving Changes..' : 'All Changes Saved.'" />
        </tidy-row>
      }
      <tidy-card class="transparent-card">
        <form [formGroup]="maintenanceForm" novalidate action="#">
          <tidy-row>
            <tidy-input
              label="Title"
              [icon]="'assets/svg/checkbox.svg'"
              [submitted]="submitted"
              class="title-input"
              [form]="maintenanceForm.get('name')"
              formControlName="name" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="Description"
              [icon]="'assets/svg/create.svg'"
              formControlName="description"
              [form]="maintenanceForm.get('description')"
              [submitted]="submitted"
              [errorMessage]="'Please enter a description.'" />
          </tidy-row>
          <tidy-row>
            <tidy-datepicker
              label="Due Next"
              [icon]="'assets/svg/calendar.svg'"
              formControlName="next_do_date"
              [form]="maintenanceForm.get('next_do_date')"
              errorMessage="Please enter a valid date."
              [submitted]="submitted" />
          </tidy-row>
          <tidy-two-column-row>
            <tidy-select
              style="max-width: 49%; margin-right: 2%;"
              label="Recur every"
              [icon]="'assets/svg/refresh-circle.svg'"
              [items]="frequencyNumberOptions"
              [submitted]="submitted"
              [form]="maintenanceForm.get('frequency_number')"
              formControlName="frequency_number" />
            <tidy-select
              style="max-width: 49%; margin: 0;"
              label="Timeframe"
              [icon]="'assets/svg/time.svg'"
              [items]="frequencyOptions"
              [submitted]="submitted"
              [form]="maintenanceForm.get('frequency')"
              formControlName="frequency" />
          </tidy-two-column-row>
          <tidy-row>
            @if (propertyOptions) {
              <tidy-select
                label="Property"
                [icon]="'assets/svg/home.svg'"
                [items]="propertyOptions"
                [submitted]="submitted"
                [form]="maintenanceForm.get('address_id')"
                formControlName="address_id"
                (optionChange)="addressChanged()" />
            }
          </tidy-row>
          <tidy-row>
            <tidy-select
              [disableElement]="maintenance"
              label="Relate the task to an item?"
              [icon]="'assets/svg/help-circle.svg'"
              [items]="[{value: 'yes', viewValue: ('Yes' | translate)}, {value: 'no', viewValue: ('No' | translate)}]"
              (optionChange)="selectItemRelation($event)"
              [form]="maintenanceForm.get('item_relation')"
              formControlName="item_relation" />
          </tidy-row>
          @if (maintenanceForm.get('item_relation').value === 'yes' && roomObjectOptions?.length > 0 && maintenanceForm.get('address_id').value) {
            <tidy-row>
              @if (!maintenanceForm.get('address_id').value) {
                <tidy-text
                  [body]="'Select a property to view items'"
                  class="red" />
              }
              @if (roomObjectOptions?.length) {
                <tidy-select
                  [disableElement]="maintenance"
                  label="Item"
                  [icon]="'assets/svg/information-circle.svg'"
                  [items]="roomObjectOptions"
                  [submitted]="submitted"
                  [form]="maintenanceForm.get('room_object_id')"
                  formControlName="room_object_id" />
              }
            </tidy-row>
          }
          @if (maintenanceForm.get('item_relation').value === 'yes' && roomObjectOptions?.length == 0 && maintenanceForm.get('address_id').value) {
            <tidy-row>
              <tidy-text
                [body]="'You haven\'t added any items added to this property. Add your first one in the restocking page.'" />
            </tidy-row>
          }
        </form>
        <!--<div class="attachments">
        <tidy-row>
          <tidy-text
            body="Photos">
          </tidy-text>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            body="+ Add Photo"
            class="link"
            (click)="$event.stopPropagation()"
            (action)="addAttachment(issue)">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-text
            body="Videos">
          </tidy-text>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            body="+ Add Video"
            class="link"
            (click)="$event.stopPropagation()"
            (action)="addAttachment(issue)">
          </tidy-text>
        </tidy-row>
        <tidy-row *ngIf="reportPhotos?.length" class="field-top-padding">
          <tidy-row>
            <tidy-text
              [body]="'Photos:'">
            </tidy-text>
          </tidy-row>
          <tidy-row *ngFor="let attachment of reportPhotos; let i = index; trackBy: trackByAttachment">
            <tidy-text *ngIf="issue"
              [actionBody]="attachment.description ?? ('Photo '+ (i+1))"
              (action)="openAttachment(attachment.photo_url)"
              class="link">
            </tidy-text>
            <tidy-text *ngIf="!issue"
              [body]="attachment.description">
            </tidy-text>
            <tidy-text
              [actionBody]="'remove'"
              (action)="removeAttachment(i, attachment)"
              class="link red">
            </tidy-text>
          </tidy-row>
        </tidy-row>
      </div>-->
    </tidy-card>
    @if (maintenance) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Delete Recurring Task'"
          class="link red"
          (action)="deleteRecurringTask()" />
      </tidy-row>
    }
    @if (!maintenance) {
      <tidy-button
        [action]="boundSaveMaintenance"
        class="primary save-issue-button"
        [text]="'Add Recurring Maintenance'" />
    }
    @if (formError) {
      <tidy-error-message
        [text]="'Please fill out all the required fields.'" />
    }
    <div style="height: 100px"></div>
  }
</tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
}
